import { getCssBasedOnRtl, media } from '../../../styles';
import { CSS_PROPERTY } from '../../../enums';
import styled from 'styled-components';

type ToggleButtonProps = {
  size: string;
};

type ToggleLabelProps = {
  labelSize?: string;
  hideToggle?: boolean;
};

export const ToggleButton = styled.button<ToggleButtonProps>`
  align-items: center;
  border: none;
  display: flex;
  background: none;
  justify-content: center;
  height: ${({ size }) => (size === 'small' ? '16px' : '20px')};
  min-height: ${({ size }) => (size === 'small' ? '16px' : '20px')};
  min-width: ${({ size }) => (size === 'small' ? '32px' : '40px')};
  outline: none;
  padding: 0;
  width: ${({ size }) => (size === 'small' ? '32px' : '40px')};

  ${media.mobilePortrait} {
    height: ${({ size }) => (size === 'small' ? '16px' : '24px')};
    width: ${({ size }) => (size === 'small' ? '32px' : '48px')};
  }

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const ToggleCategoriesButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  display: flex;
  height: 16px;
  justify-content: center;
  padding: 0;
  width: 32px;
`;

export const ToggleLabel = styled.label<ToggleLabelProps>`
  cursor: pointer;
  display: inline-flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  font-size: ${({ theme }) => theme.typography.size.small};
  ${({ hideToggle, theme }) =>
    getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, hideToggle ? 0 : theme.spacing.base.xxs)};
  white-space: nowrap;

  ${media.mobilePortrait} {
    align-items: center;
    ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.mobile.xl)};
    + div {
      ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_LEFT, theme.spacing.mobile.xl)};
    }
  }
`;

export const ToggleContainer = styled.div`
  align-items: center;
  display: flex;
  width: 100%;

  &:not(:last-child) {
    ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.xs)};
  }

  ${media.mobilePortrait} {
    &:not(:last-child) {
      ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, 0)};
    }
  }
`;
